import {
	GLOBAL_DATA_LOADING,
	GLOBAL_DATA_GET,
	GLOBAL_DATA_ERROR
} from '../actions/types';

const initialState = {
	global_data_loading: false,
	global_data: {},
	global_errors: {}
}

export default function globalReducer(state = initialState, action){
	switch(action.type){
		case GLOBAL_DATA_LOADING:
			return {
				...state,
				global_data_loading: true
			}
		case GLOBAL_DATA_GET:
			delete state.global_errors.global_data
			return {
				...state,
				global_data_loading: false,
				global_data: action.payload
			}
		case GLOBAL_DATA_ERROR:
			return {
				...state,
				global_data_loading: false,
				global_errors: {
					...state.global_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
